import { DateTime } from '@ksyos/date-time';
import { Button, Card, Form, FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import _ from 'lodash';
import { useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { hasOneAuthorization } from '@frontend/utils';
import type { IServiceOrganizationSettings } from '../../../interfaces/serviceOrganizationSettings';
import type { IServiceGroupOrganizationSettingsProps } from './ServiceGroupOrganizationSettings';
import { translateKey } from '../../../../translate';
import { ServiceOrganizationSettingStopModal } from './ServiceOrganizationSettingStopModal';

export function ServiceGroupOrganizationStatusSettings(props: IServiceGroupOrganizationSettingsProps) {
    const canEdit = hasOneAuthorization(ManagerAuthorization.organizationAddEdit);
    const [showStopServiceGroupModal, setShowStopServiceGroupModal] = useState(false);

    function getEarliestOrLatestServiceOrganizationSettingForServiceGroup(
        OrganizationServiceSettings: IServiceOrganizationSettings[],
        getLatest?: boolean
    ) {
        const orderBy = getLatest ? 'desc' : 'asc';
        const sortedServiceOrganizationSettings = _.orderBy(OrganizationServiceSettings, 'startDate', orderBy);

        return sortedServiceOrganizationSettings[0]?.startDate;
    }

    if (props.serviceOrganizationSettings.length === 0) {
        return null;
    }

    return (
        <>
            <Card>
                <Card.Transition type={'read'} />
                <Card.Header title={translateKey('common.status')} />
                <Card.Body>
                    <Form submitOnEnter={false}>
                        <FormSection>
                            <FormGroup label={translateKey('common.activeSince')}>
                                {getEarliestOrLatestServiceOrganizationSettingForServiceGroup(
                                    props.serviceOrganizationSettings
                                ) && (
                                    <FormParagraph>
                                        {DateTime.from(
                                            getEarliestOrLatestServiceOrganizationSettingForServiceGroup(
                                                props.serviceOrganizationSettings
                                            )
                                        ).format('DD-MM-YYYY')}
                                    </FormParagraph>
                                )}
                            </FormGroup>
                        </FormSection>
                    </Form>
                </Card.Body>
                {someServiceOrganizationSettingsDontHaveEndDate() && canEdit && (
                    <Card.Footer>
                        <Button
                            onClick={() => setShowStopServiceGroupModal(true)}
                            variant="link"
                        >
                            {translateKey('service.stopService', props.serviceOrganizationSettings[0].serviceGroupName)}
                        </Button>
                    </Card.Footer>
                )}
            </Card>

            {showStopServiceGroupModal && (
                <ServiceOrganizationSettingStopModal
                    onClose={() => setShowStopServiceGroupModal(false)}
                    organizationName={props.serviceOrganizationSettings[0].organization.name}
                    reloadServiceOrganizationSetting={props.reloadServiceOrganizationSettings}
                    serviceOrganizationSettingIds={props.serviceOrganizationSettings.map(
                        (serviceOrganizationSetting) => serviceOrganizationSetting.id
                    )}
                    serviceOrServiceGroupOrCarePathName={props.serviceOrganizationSettings[0].serviceGroupName}
                    startDate={getEarliestOrLatestServiceOrganizationSettingForServiceGroup(
                        props.serviceOrganizationSettings,
                        true
                    )}
                />
            )}
        </>
    );

    function someServiceOrganizationSettingsDontHaveEndDate() {
        return props.serviceOrganizationSettings.some(
            (serviceOrganizationSetting) => !serviceOrganizationSetting.endDate
        );
    }
}
